import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(() => localStorage.getItem("dib-customer-token"));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (token) {
            axios.get(`${API_BASE}/auth/me`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => setUser(res.data))
            .catch(() => { localStorage.removeItem("dib-customer-token"); setToken(null); setUser(null); })
            .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, [token]);

    const login = async (email, password) => {
        const res = await axios.post(`${API_BASE}/auth/login`, { email, password });
        localStorage.setItem("dib-customer-token", res.data.token);
        setToken(res.data.token);
        setUser(res.data.user);
        return res.data;
    };

    const register = async (data) => {
        const res = await axios.post(`${API_BASE}/auth/register`, data);
        localStorage.setItem("dib-customer-token", res.data.token);
        setToken(res.data.token);
        setUser(res.data.user);
        return res.data;
    };

    const logout = () => {
        localStorage.removeItem("dib-customer-token");
        setToken(null);
        setUser(null);
    };

    const getAuthHeaders = () => token ? { Authorization: `Bearer ${token}` } : {};

    return (
        <AuthContext.Provider value={{ user, token, loading, login, register, logout, getAuthHeaders }}>
            {children}
        </AuthContext.Provider>
    );
};
